<template>
  <div class="cooperation height">
    <div class="cooperation-wrap col-xs-10 col-sm-10 col-md-6">
      <div class="cooperation-top">
        <h1 class="cooperation-title">合作机构</h1><br/>
        <span>COOPERATIVE AGENCIES</span>
      </div>
      <div class="slider visible-xs-block visible-sm-block" >
        <el-carousel style="height:500px;" :interval="5000" arrow="always" :loop="false">
          <el-carousel-item v-for="item in 1" :key="item">
            <div v-for="v in 1" :key="v">
              <img class="cooperation-img" src="../assets/untitled-14.png">
              <img class="cooperation-img" src="../assets/untitled-15.png">
              <img class="cooperation-img" src="../assets/untitled-16.png">
              <img class="cooperation-img" src="../assets/untitled-17.png">
              <img class="cooperation-img" src="../assets/untitled-18.png">
              <img class="cooperation-img" src="../assets/untitled-18.png">
              <img class="cooperation-img" src="../assets/untitled-14.png">
              <img class="cooperation-img" src="../assets/untitled-15.png">
              <img class="cooperation-img" src="../assets/untitled-16.png">
              <img class="cooperation-img" src="../assets/untitled-17.png">
              <img class="cooperation-img" src="../assets/untitled-18.png">
              <img class="cooperation-img" src="../assets/untitled-18.png">
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="slider center visible-md-block visible-lg-block" >
        <el-carousel style="height:400px;padding-top: 40px;" :interval="5000" arrow="always">
          <el-carousel-item v-for="item in 4" :key="item">
            <div v-for="v in 3" :key="v">
              <img class="cooperation-img" src="../assets/untitled-14.png">
              <img class="cooperation-img" src="../assets/untitled-15.png">
              <img class="cooperation-img" src="../assets/untitled-16.png">
              <img class="cooperation-img" src="../assets/untitled-17.png">
              <img class="cooperation-img" src="../assets/untitled-18.png">
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Cooperation",
    data() {
      return {
        style: ''
      }
    },
    methods:{
    },
    mounted() {
      this.style = `height:${window.innerHeight -60}px;`
    },
  }
</script>

<style lang="scss" scoped>
  @import '../assets/scss/index.scss';
  @media screen and (min-width:0px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 730px;
    }
  }
  @media screen and (min-width:900px) and (max-width:1200px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 800px;
    }
  }
  @media screen and (min-width:600px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 870px;
    }
  }
  @media screen and (min-width: 1200px) {
    .height{
      // height: 600px;
      height: calc(100vh - 60px);
    }
  }
  @media screen and (max-width: 768px) {
      // .height{
      //   height: 730px;
      // }
       .cooperation-img{
        // @include px2rem(width, );
        // width: 20%;
        /*width: 14%;*/
        height: 80px;
        padding: 10px 12px;
      }
      .slider{
          // @include px2rem(width, 1000);
          width: 100%;
          /*width: 60%;*/
          margin: 0 auto;
          // @include px2rem(height, 800);
          height: 500px;
          /*height: 300px;*/
          background: #ffffff;
          overflow: hidden;
        }
  }
  @media screen and (min-width: 768px) {
    .slider{
      // @include px2rem(width, 1000);
      // /*width: 60%;*/
      width: 90%;
      margin: 0 auto;
      // @include px2rem(height, 500);
      height: 400px;
      /*height: 300px;*/
      background: #ffffff;
    }
    .cooperation-img{
      @include px2rem(width, 206);
      /*width: 14%;*/
      padding: 20px 12px;
    }
  }
  .cooperation{
    width: 100%;
    background: url("../assets/untitled-19.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cooperation-wrap{
    // @include px2rem(width, 1680);
    // /*width: 80%;*/
    width: 100%;
  }
  .cooperation-top{
    /*padding-top: 60px;*/
    @include px2rem(margin-bottom, 55);
    /*margin-bottom: 40px;*/
  }
  .cooperation-title{
    // @include px2rem(font-size, 30);
  }


</style>



// WEBPACK FOOTER //
// src/components/Cooperation.vue